<template>
  <div class="white-card">
    <div class="white-card-header">
      <div class="title-wrap">
        <label class="title-label">{{
          label.get("integration_payroll")
        }}</label>
        <!-- <i class="atto info-icon"
            id="tooltip-payroll"></i>
        <b-tooltip
            target="tooltip-payroll"
            custom-class="info-tooltip"
            placement="bottom" >
          <label>Payroll</label>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
        </b-tooltip>-->
      </div>
    </div>
    <div class="payroll-body">
      <div class="d-flex flex-column total-pay">
        <label>{{ label.get("est_total_pay") }}</label>
        <span>{{ payrollData.est_total_pay }}</span>
        <!--        <span class="green">+10%</span>-->
      </div>

      <div class="d-flex flex-column payroll-progress">
        <div
          class="d-flex flex-row align-content-center justify-content-between"
        >
          <label class="left-label">{{ label.get("total_paid_hours") }}</label>
          <label class="right-label">{{
            label.get("total_unpaid_hours")
          }}</label>
        </div>
        <div class="payroll-progressbar">
          <span
            v-bind:style="{ width: payrollData.bar_percentage + '%' }"
          ></span>
        </div>
        <div
          class="d-flex flex-row align-content-center justify-content-between"
        >
          <span>{{ payrollData.paid_hours }}</span>
          <span>{{ payrollData.unpaid_hours }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimesheetPayrollComponent",
  props: {
    payroll: {
      type: Object,
      default: {
        bar_percentage: 0,
        est_total_pay: "-",
        paid_hours: "-",
        unpaid_hours: "-",
      },
    },
  },
  computed: {
    payrollData() {
      if (this.payroll !== undefined && this.payroll !== null) {
        return this.payroll;
      }

      return {
        bar_percentage: 0,
        est_total_pay: "-",
        paid_hours: "-",
        unpaid_hours: "-",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.white-card {
  overflow: hidden;
  height: 268px !important;
}
.payroll-body {
  padding-top: 0 !important;
  .total-pay {
    height: 107px;
    padding-top: 17px;
  }
  .payroll-progress {
    margin-top: 18px;

    label {
      margin: 0 !important;
      &.left-label {
        text-align: left;
        padding-right: 20px;
      }
      &.right-label {
        text-align: right;
      }
    }

    span {
      font-size: 1.125rem;
    }
    .payroll-progressbar {
      width: 100%;
      height: 6px;
      background-color: #00b9cb;
      display: flex;
      margin-bottom: 8px;

      span {
        background-color: #00b9cb;
        border-right: 2px solid #ffffff;
        transition: width 700ms ease;
      }
    }
  }
}
</style>
